import { createContext, useContext, useState, useEffect } from 'react';
import { useUser } from './UserContext';
import api from '../utils/api';

const AssignedToContext = createContext();

export const AssignedToProvider = ({ children }) => {
  const { user } = useUser();
  const [assignedToList, setAssignedToList] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const fetchAssignedToList = async (force = false, params = {}) => {
    const hasParams = params && Object.keys(params).length > 0;
    if (isFetching || (!force && isFetched && !hasParams)) return;
    try {
      setIsFetching(true);
      const res = await api.get('/ticket/assigned-list', { params });
      setAssignedToList(res.data);
      setIsFetched(true);
    } catch (err) {
      console.error('Error fetching assigned users:', err);
      setAssignedToList([]);
      setIsFetched(true);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && user) {
      fetchAssignedToList();
    }
  }, [user]);

  return (
    <AssignedToContext.Provider value={{ assignedToList, fetchAssignedToList }}>
      {children}
    </AssignedToContext.Provider>
  );
};

export const useAssignedTo = () => {
  const context = useContext(AssignedToContext);
  if (!context) {
    throw new Error('useAssignedTo must be used within an AssignedToProvider');
  }

  return context;
};
